import { component as defineComponent } from 'flightjs';
import EmailSubscriptionService from '@99designs/email-subscription-service';

function BriefEmailBeforeSignupField() {
    this.attributes({
        broadcastEvent: 'uiBriefEmailBeforeSignupChanged',
    });

    this.subscribe = function(e) {
        const emailService = new EmailSubscriptionService(window.analytics);

        emailService.subscribe({
            email: e.target.value,
            acquisition_source: 'launch',
            custom_data: {
                draft_id: this.$node.attr('data-draft-id'),
                category_key: this.$node.attr('data-category-key'),
            },
        });
    };

    this.broadcastAction = function(e) {
        this.trigger(this.attr.broadcastEvent, {
            value: e.target.value,
        });
    };

    this.after('initialize', function() {
        this.on('change', this.subscribe);
        this.on('change', this.broadcastAction);
    });
}

export default defineComponent(BriefEmailBeforeSignupField);



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/brief-email-before-signup-field.js